import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { CLOSE_SVGA_DIALOG } from "../../store/gift/types";
import { connect, useDispatch, useSelector } from "react-redux";
import { createNewGiftSvga } from "../../store/gift/action";
import SVGA from "svgaplayerweb";
import { permissionError } from "../../util/Alert";
import { baseURL } from "../../util/Config";
import { Cancel } from "@mui/icons-material";
import { getCategory } from "../../store/giftCategory/action";
import { Cropper } from "react-advanced-cropper";
import html2canvas from "html2canvas";
import { createReactionSVGA } from "../../store/reaction/action";
import { CLOSE_AVATAR_SVGA_DIALOG } from "../../store/AvatarFrame/type";
import {
  createAvatarSVGA,
  updateAvatarFrame,
} from "../../store/AvatarFrame/action";

const AvatarSvgaDialog = (props) => {
  const dispatch = useDispatch();
  const {
    Dialogue1: open,
    DialogueData1,
    gift,
  } = useSelector((state) => state.avatarFrame);
  console.log('DialogueData1: ', DialogueData1);

  const categories = useSelector((state) => state.giftCategory.giftCategory);
  const [images, setImages] = useState([]);
  const [imageData, setImageData] = useState(null);
  console.log('imageData: ', imageData);
  const [imagePath, setImagePath] = useState(null);
  const [mongoId, setMongoId] = useState("");
  const [coin, setCoin] = useState(0);
  const [isSvga, setIsSvga] = useState(false);
  const [image, setImage] = useState();
  const [cropper, setCropper] = useState(null);
  const [isSubmit, setIsSubmit] = useState(true);
  const [name, setName] = useState("");
  const [diamond, setDiamond] = useState(0);
  const [nameError, setNameError] = useState("");
  const imageRef = useRef(null);
  const [validity, setValidity] = useState("");
  const [validityType, setValidityType] = useState("");

  const [errors, setError] = useState({
    name: "",
    image: "",
    validity: "",
    imagePath: "",
  });


  useEffect(() => {
    dispatch(getCategory());
  }, [dispatch]);

  useEffect(() => {
    setIsSubmit(true);
  }, [open]);


  useEffect(() => {
    if (DialogueData1) {
      setValidity(DialogueData1?.validity);
      setValidityType(DialogueData1?.validityType);
      setMongoId(DialogueData1._id);
      setName(DialogueData1?.name)
      setDiamond(DialogueData1.diamond);
      setImagePath(baseURL + DialogueData1.image);
      if (DialogueData1?.image?.split(".")?.pop() === "svga") {
        setIsSvga(true);
      }
    }
  }, [DialogueData1]);





  useEffect(() => {
    if (isSvga) {
      const container = document.getElementById("svga");
      if (container && imagePath) {
        const player = new SVGA.Player(container);
        const parser = new SVGA.Parser(container);

        const loadSvga = (url) => {
          parser.load(url, function (videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
            setTimeout(() => {
              captureAndSendImage(player, mongoId);
            }, 3000);
          }, function (error) {
            console.error("SVGA load error:", error);
          });
        };

        if (imageData?.preview) {

          loadSvga(imageData.preview);
        } else {
          loadSvga(baseURL + DialogueData1?.image);
        }
      }
    } else {
      setIsSubmit(false);
    }
  }, [imageData, isSvga, imagePath]);



  useEffect(
    () => () => {
      setError({
        diamond: "",
        image: "",
      });
      setMongoId("");
      setName("")
      setImages([]);
      setImageData(null);
      setImagePath(null);
      setIsSvga(false);
      setDiamond("");
      setNameError("");
    },
    [open]
  );

  const handleInputImage = (e) => {
    setImage("");
    if (e.target.files[0]) {
      Object.assign(e.target.files[0], {
        preview: URL.createObjectURL(e.target.files[0]),
      });
      setImageData(e.target.files[0]);
      setImages([e.target.files[0]]);
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        setImagePath(reader.result);
        setError({
          image: "",
        });
      });
      reader.readAsDataURL(e.target.files[0]);

      if (e.target.files[0].name.split(".").pop() === "svga") {
        setIsSvga(true);
      } else {
        setIsSvga(false);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const errors = {};

    // New error handling for required fields
    if (diamond === 0 || !diamond) {
      errors.diamond = "Diamond is required.";
    }

    if (!name) {
      errors.name = "Name is required.";
    }

    if (!imagePath) {
      errors.imagePath = "Please select Gift!";
    }

    if (!validity) {
      errors.validity = "Validity is required.";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    // setIsSubmit(false)

    formData.append("validity", validity);
    formData.append("validityType", validityType ? validityType : "day");
    formData.append("name", name);

    formData.append("svgaImage", image);
    formData.append("diamond", diamond);

    if (mongoId) {
      formData.append("image", imageData);
    } else {
      for (let i = 0; i < images.length; i++) {
        formData.append("image", images[i]);
      }
    }

    if (mongoId) {
      dispatch(updateAvatarFrame(mongoId, formData));
      closePopup();
    } else {
      closePopup();
      dispatch(createAvatarSVGA(formData));
    }

    // return setError({ ...errors });
  };

  const closePopup = () => {
    dispatch({ type: CLOSE_AVATAR_SVGA_DIALOG });
  };


  const onChange = (cropperRef) => {
    setCropper(cropperRef);
  };

  const captureAndSendImage = async (player, index) => {
    player.pauseAnimation();

    const canvasElement = document.querySelector(
      `div#svga canvas`
    );

    if (!canvasElement) return;

    const canvas = await html2canvas(canvasElement, {
      scale: 1,
      useCORS: true,
      backgroundColor: "rgba(0, 0, 0, 0)",
      onclone: (cloneDoc) => {
        const clonedCanvas = cloneDoc.querySelector(`canvas`);
        if (clonedCanvas) clonedCanvas.style.backgroundColor = "transparent";
      },
    });

    canvas.toBlob((blob) => {
      setImage(blob);
      setIsSubmit(false);
    }, "image/png");
  };


  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
        sx={{
          '& .css-1kxd7on-MuiDialogContent-root': {
            overflowY: "hidden",
            overflowX: "hidden"
          }
        }}
      >

        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4"> SVGA </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <div
                style={{ position: "absolute", opacity: "0", zIndex: "-111", overflowY: "hidden !important" }}
              >
                <Cropper
                  defaultCoordinates={{
                    height: 221,
                    left: 77,
                    top: 128,
                    width: 192,
                  }}
                  src={image}
                  onChange={onChange}
                  className={"cropper"}
                />
                <img
                  ref={imageRef}
                  src={image}
                  alt="Original"
                  style={{ display: "none" }}
                />
              </div>
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">Validity</label>
                      <input
                        type="number"
                        className="form-control"
                        required=""
                        placeholder="1"
                        min="0"
                        value={validity}
                        onChange={(e) => {
                          setValidity(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              validity: "Validity is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              validity: "",
                            });
                          }
                        }}
                      />
                      {errors.validity && (
                        <div className="ml-2 mt-1">
                          {errors.validity && (
                            <div className="pl-1 text__left">
                              <span className="text-red">
                                {errors.validity}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="text-gray mb-2">Validity Type</label>
                      <select
                        className="form-select form-control"
                        aria-label="Default select example"
                        value={validityType}
                        onChange={(e) => {
                          setValidityType(e.target.value);
                        }}
                      >
                        <option value="day">Day</option>
                        <option value="Month">Month</option>
                        <option value="year">Year</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-group col-12 mt-3">
                    <label className="mb-2 text-gray">Diamond</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Diamond"
                      required
                      value={diamond}
                      onChange={(e) => {
                        setDiamond(e.target.value.trim());
                        if (!e.target.value) {
                          return setError({
                            ...errors,
                            diamond: "Diamond is Required!",
                          });
                        } else {
                          return setError({
                            ...errors,
                            diamond: "",
                          });
                        }
                      }}
                    />
                    {errors.diamond && (
                      <div className="ml-2 mt-1">
                        {errors.diamond && (
                          <div className="pl-1 text__left">
                            <span className="text-red">{errors.diamond}</span>
                          </div>
                        )}
                      </div>
                    )}
                    <div className="form-group mt-4">
                      <label className="text-gray mb-2">Name</label>

                      <input
                        type="text"
                        className="form-control"
                        required=""
                        placeholder="Name"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              name: "Name is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              name: "",
                            });
                          }
                        }}
                      />

                      {errors.name && (
                        <div className="ml-2 mt-1">
                          {errors.name && (
                            <div className="pl-1 text__left">
                              <span className="text-red">{errors.name}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="mb-2 mt-2 text-gray">Icon</label>

                    <>
                      <input
                        className="form-control"
                        type="file"
                        required=""
                        accept=".svga, .gift"
                        onChange={handleInputImage}
                      />
                      {errors.image && (
                        <div className="ml-2 mt-1">
                          {errors.image && (
                            <div className="pl-1 text__left">
                              <span className="text-red">{errors.image}</span>
                            </div>
                          )}
                        </div>
                      )}
                      {imagePath && (
                        <Fragment>
                          {!isSvga ? (
                            <img
                              src={imagePath}
                              className="mt-3 rounded float-left mb-2"
                              height="100px"
                              width="100px"
                            />
                          ) : (
                            <>
                              <div
                                id="svga"
                                style={{
                                  boxShadow:
                                    "0 5px 15px 0 rgb(105 103 103 / 00%)",
                                  float: "left",
                                  objectFit: "contain",
                                  marginRight: 15,
                                  width: "350px",
                                  marginBottom: "10px",
                                  height: "350px",
                                }}
                              ></div>
                            </>
                          )}
                        </Fragment>
                      )}
                    </>
                    {/* )} */}
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    disabled={isSubmit}
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { getCategory, createNewGiftSvga })(
  AvatarSvgaDialog
);
